<!-- @format -->

<ng-container *transloco="let t">
  <h3>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.HEADINGS.SECONDARY_ATTAINMENTS") }}</h3>
  @for (secondaryAttainment of secondaryAttainments; track secondaryAttainment) {
    <sis-expandable [level]="4" [variant]="'naked-dotted'" [title]="(secondaryAttainment | attainmentCode | async) + ','">
      <ng-template sisExpandableCustomTitle>
        {{ t("ENTITY_NAMES.Attainment") }} {{ secondaryAttainment.attainmentDate | localDateFormat }} –
        {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE") }}
        {{ secondaryAttainment.gradeId | grade: secondaryAttainment.gradeScaleId : "ABBREVIATION" | async }}
        ({{ secondaryAttainment.gradeId | grade: secondaryAttainment.gradeScaleId : "NAME" | async }})
      </ng-template>
      <ng-template sisExpandableContent>
        <dl>
          <div class="form-group-mimic" role="listitem">
            <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.GRADE") }}</dt>
            <dd>
              {{ secondaryAttainment.gradeId | grade: secondaryAttainment.gradeScaleId : "ABBREVIATION" | async }}
              ({{ secondaryAttainment.gradeId | grade: secondaryAttainment.gradeScaleId : "NAME" | async }})
            </dd>
          </div>
          <div class="form-group-mimic" role="listitem">
            <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.CREDITS_LABEL") }}</dt>
            <dd>
              {{ secondaryAttainment.credits }} {{ t("CREDITS") }}
              @if (secondaryAttainment.studyWeeks) {
                ({{ secondaryAttainment.studyWeeks }} {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.STUDY_WEEKS_ABBR") }})
              }
            </dd>
          </div>
          <div class="form-group-mimic" role="listitem">
            <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ATTAINMENT_DATE") }}</dt>
            <dd>{{ secondaryAttainment.attainmentDate | localDateFormat }}</dd>
          </div>
          <div class="form-group-mimic" role="listitem">
            <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.EXPIRY_DATE") }}</dt>
            @if (secondaryAttainment.expiryDate) {
              <dd>{{ secondaryAttainment.expiryDate | localDateFormat }}</dd>
            }
            @if (!secondaryAttainment.expiryDate) {
              <dd>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.NO_EXPIRY_DATE") }}</dd>
            }
          </div>
          <div
            sis-additional-info-details
            class="form-group-mimic full-width"
            role="listitem"
            [data]="secondaryAttainment.additionalInfo"></div>
          <div class="form-group-mimic" role="listitem">
            <dt> {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ACCEPTOR_PERSONS") }} </dt>
            @if (secondaryAttainment.acceptorPersons?.length > 0) {
              @for (acceptor of secondaryAttainment.acceptorPersons; track acceptor) {
                @if (acceptor.personId) {
                  <dd>{{ acceptor.personId | publicPerson | async | personFullNameReversed }}</dd>
                }
                @if (!acceptor.personId) {
                  <dd>{{ acceptor.text | localizedString }}</dd>
                }
              }
            } @else {
              <dd> - </dd>
            }
          </div>
        </dl>
      </ng-template>
    </sis-expandable>
  }
</ng-container>
